import { render, staticRenderFns } from "./WordStatistics.vue?vue&type=template&id=1bc50a7d&scoped=true&"
import script from "./WordStatistics.vue?vue&type=script&lang=js&"
export * from "./WordStatistics.vue?vue&type=script&lang=js&"
import style0 from "./WordStatistics.vue?vue&type=style&index=0&id=1bc50a7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc50a7d",
  null
  
)

export default component.exports